import { useGaiaStoreContainerActions } from "@/engine/viewer/core/useGaiaStoreContainer";
import { LayerDto, MaterialDto } from "@/types/data-types";
import { AnimatePresence, motion } from "motion/react";
import React, { useEffect, useState } from "react";
import { InspectorPanel } from "./panel/InspectorPanel";

const DEFAULT_MATERIAL_PROPERTIES = {
  side: 0,
  color: "#fff",
  opacity: 1,
  roughness: 1,
  metalness: 0,
  emissive: "#000",
};

interface VaultObjectInspectorProps {
  layerInfo: LayerDto;
}

export const VaultObjectInspector = ({
  layerInfo,
}: VaultObjectInspectorProps) => {
  const { changeViewingHengeLayers } = useGaiaStoreContainerActions();

  const [currentMaterial, setCurrentMaterial] = useState<MaterialDto>(
    layerInfo.material || DEFAULT_MATERIAL_PROPERTIES,
  );

  useEffect(() => {
    setCurrentMaterial(layerInfo.material || DEFAULT_MATERIAL_PROPERTIES);
  }, [layerInfo.path]);

  useEffect(() => {
    changeViewingHengeLayers((prevLayers) =>
      prevLayers
        ? prevLayers.map((layer) =>
            layer.path === layerInfo.path
              ? {
                  ...layer,
                  material: currentMaterial,
                }
              : layer,
          )
        : prevLayers,
    );
  }, [currentMaterial]);

  return (
    <div className="pointer-events-auto relative">
      <AnimatePresence>
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          <InspectorPanel
            layerInfo={layerInfo}
            currentMaterial={currentMaterial}
            setCurrentMaterial={setCurrentMaterial}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

VaultObjectInspector.displayName = "VaultObjectInspector";
